import {TableColumn, TableRowRequired} from './BasicTable';

export function createBasicTableColumn<RowData extends TableRowRequired>(
  id: string,
  label: string,
  options: Omit<TableColumn<RowData>, 'id' | 'label'> = {}
): TableColumn<RowData> {
  return {
    id,
    label,
    ...options,
  };
}
